module.exports = __webpack_public_path__ + "static/media/paste.27b0bfc0.svg";